import React from "react";
import InfiniteTable from "../../../components/InfiniteTable/InfiniteTable";
import { Link } from "react-router-dom";
import { Container, Button, Typography, useTheme } from "@mui/material";

const columns = [
  { id: "id", editable: "/user", editablePk: "id", label: "Users ID" },
  {
    id: "username",
    label: "Username",
  },
  { id: "email", label: "Email Address" },
  {
    id: "first_name",
    label: "First Name",
  },
  {
    id: "last_name",
    label: "Last Name",
  },
];

export const Users = (props) => {
  const theme = useTheme();

  return (
    <>
      <Container style={{ textAlign: "right", marginBottom: theme.spacing(3) }}>
        <Link
          to="/user/add"
          style={{ textDecoration: "none" }}
          color="secondary"
        >
          <Button variant="contained" color="primary">
            <Typography variant="subtitle2" className="text-white">
              Add User
            </Typography>
          </Button>
        </Link>
      </Container>
      <Container>
        <InfiniteTable
          {...props}
          apiep="users"
          columns={columns}
          data={null}
          dataMapByColumn="id"
          deletable={false}
          editable={true}
          filterable={true}
          label="Users"
          fetchingModal={null}
        />
      </Container>
    </>
  );
};

export default Users;
